import React from "react";
import { motion } from "framer-motion";
import { STATS } from "../../data";

export default function Stats() {
  return (
    <section className="bg-espana-red text-white py-16 lg:py-20">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {STATS.map((s, i) => (
            <motion.div
              key={s.label}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              data-testid={`stat-${i}`}
              className="text-center md:text-left"
            >
              <div className="text-5xl lg:text-6xl font-black tracking-tighter text-espana-gold">
                {s.value}
              </div>
              <div className="mt-2 text-sm font-medium text-white/80 uppercase tracking-wide">
                {s.label}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
